import React from "react";
import Form from "react-bootstrap/Form";
import Select from 'react-select';
import GetCustomers from '../customers/get_customers/';
import Button from 'react-bootstrap/Button';

function NewSalesLead(){

  // Customer with react-select
    // Option to create new customer
  var Customer = 0;
  const Customers = GetCustomers();
  const handleCustomerChange = (event) => {
    Customer = event.value;
  }

  // Description
  var Description = "";
  const handleDescriptionChange = () => {
    var description_select = document.getElementById('Description');
    Description = description_select.value;
  };

  // Type
  const Types = [
    { label: 'Supply & Fit', value: 'Supply & Fit' },
    { label: 'Supply Only', value: 'Supply Only' },
    { label: 'Whipping & Binding', value: 'Whipping & Binding' }
  ];
  var Type = "";
  const handleTypeChange = (event) => {
    Type = event.value;
  };

  // Submit
  const submit = async () => {
    var myData = {
        customer_id: Customer,
        description: Description,
        type: Type,
        status: "In Progress"
    }

    const result = await fetch(import.meta.env.VITE_URL + '/salesleads', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(myData)
      })
      const resultInJson = await result.json()
  }

  return (
    <Form>
      <h1> New Sales Lead </h1>
      <div className="mb-3">
        <Form.Text>
          Select a Customer.
          <Select
            options={Customers.map(opt => ({ label: opt.customerdisplayname, value: opt.id }))}
            onChange={event => handleCustomerChange(event)}
            className="mb-3 col-6"
            aria-label="Customers"
          />
        </Form.Text>
      </div>
      <div className="mb-3">
        <Form.Text>
          Enter a brief description for this Sales Lead.
          <Form.Control
            type="string"
            id="Description"
            onChange={handleDescriptionChange}
          />
        </Form.Text>
      </div>
      <div className="mb-3">
        <Form.Text>
          <Select
            options={Types}
            onChange={event => handleTypeChange(event)}
          />
        </Form.Text>
      </div>
      <div className="mt-3">
        <Button type="submit" onClick={submit}>Submit form</Button>
      </div>
    </Form>
  );

};

export default NewSalesLead
